import React from "react";
import { FaLinkedinIn, FaEnvelope } from "react-icons/fa";

const contacts = [
  {
    icon: <FaLinkedinIn />,
    label: "LinkedIn",
    display: "andreas-wallin",
    href: "https://www.linkedin.com/in/andreas-wallin-abb4b515a",
    external: true,
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    display: "me@andreaswallin.com",
    href: "mailto:me@andreaswallin.com",
    external: false,
  },
];

function Contact() {
  return (
    <section id="contact" className="py-24 px-6 fade-section">
      <div className="max-w-3xl mx-auto">
        <p className="text-sm text-accent tracking-widest uppercase mb-4">
          Contact
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
          Get in touch
        </h2>
        <p className="text-neutral-400 leading-relaxed mb-12">
          Have a project in mind or just want to say hi? Feel free to reach out.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          {contacts.map(({ icon, label, display, href, external }) => (
            <a
              key={label}
              href={href}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              className="flex items-center gap-4 flex-1 bg-dark-card border border-dark-border rounded-xl p-6 hover:border-accent transition-colors group"
            >
              <span className="text-xl text-accent">{icon}</span>
              <div>
                <p className="text-xs text-neutral-500 uppercase tracking-wider mb-1">
                  {label}
                </p>
                <p className="text-sm text-neutral-300 group-hover:text-white transition-colors">
                  {display}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Contact;
